const STATUS = {
    idle: 'idle',
    pending: 'pending',
    fulfilled: 'fulfilled',
    rejected: 'rejected'
}
export default STATUS